export enum EOrderStepsAccreditationStatus {
  waiting = 'DOCUMENT_WAITING',
  processing = 'DOCUMENT_CHECKING',
  active = 'ACTIVE',
}
